export default __webpack_public_path__ + "static/media/element_57.e16738a6.avif";